import React from 'react';
import {Button, Card, CardBody, CardHeader, Table} from 'reactstrap';
import ReactToPrint from 'react-to-print';
import BoxItemListItem from './BoxItemListItem';

class BoxItemBody extends React.Component {
    calculateStatistics = (items) => {
        const total = items.length;
        const productItems = items.map(item => item.products);
        const products = [].concat(...productItems);
        const types = {}

        for (let product of products) {
            const {type, quantity} = product;
            const vQuantity = (quantity && parseInt(quantity, 10)) || 1;
            if (types[type]) types[type] += vQuantity;
            else types[type] = vQuantity;
        }

        return {total, types};
    }

    render() {
        const {items, boxId} = this.props;
        const statistics = this.calculateStatistics(items);
        const typeEntries = Object.entries(statistics.types);

        return (
            <CardBody>
                <h4>Hộp số #{boxId} - {statistics.total} đơn hàng</h4>
                {
                    typeEntries.map(([key, value]) => {
                        return <p key={key}>{key}: {value}</p>;
                    })
                }
                <Table responsive>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>ID</th>
                        <th>Order Number</th>
                        <th>Tracking</th>
                        <th>Thời gian đóng hộp</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        items.map((item, index) => {
                            return <BoxItemListItem key={index} pos={index + 1} item={item}/>;
                        })
                    }
                    </tbody>
                </Table>
            </CardBody>
        );
    }
}

class BoxItemList extends React.Component {
    render() {
        const {items, boxId} = this.props;

        return (
            <Card className="BoxItemList">
                <CardHeader>
                    <h4 className="d-flex justify-content-between align-items-center w-100 font-weight-bold mb-3">
                        <span>Danh sách item</span>
                        <ReactToPrint
                            trigger={() => <Button color="light" className="btn-labeled btn-labeled-left ml-1">
                                <b><i className="icon-printer2"/></b>
                                Print Items
                            </Button>}
                            content={() => this.listItemRef}
                        />
                    </h4>
                </CardHeader>
                <BoxItemBody ref={el => (this.listItemRef = el)} items={items} boxId={boxId}/>
            </Card>
        );
    }
}

export default BoxItemList;
